import { Box, Breadcrumbs, SxProps, Tab, Tabs, Theme, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { Link as ReactRouterLink, useLocation, useRouteMatch } from 'react-router-dom';

const breadcrumbContentStyles: SxProps<Theme> = {
  padding: 2,
};

export function ApprovalWorkflowNavigationHeader() {
  const { url } = useRouteMatch();
  const currentTab = 'contractReview';
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(currentTab);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/contractReview')) {
      setActiveTab('contractReview');
    } else if (path.includes('/Names')) {
      setActiveTab('nameUpdate');
    }
  }, [location.pathname]);

  return (
    <>
      <Box sx={breadcrumbContentStyles}>
        <Box style={{ display: 'flex', justifyContent: 'space-between', flexFlow: 'row' }}>
          <Breadcrumbs separator='>' aria-label='approval workflow'>
            <Typography color='text.primary'>Approval Workflow</Typography>
          </Breadcrumbs>
        </Box>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} textColor='secondary' indicatorColor='secondary' aria-label='approval workflow'>
          <Tab value='contractReview' label='Contracts' component={ReactRouterLink} to={`${url}/contractReview`} />
          <Tab value='nameUpdate' label='Name' component={ReactRouterLink} to={`${url}/Names`} />
        </Tabs>
      </Box>
    </>
  );
}
